import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber
  } from "../../commonFunctions";
  
  const villagemaster = {
    label: "Village Master",
    starting: true,
    url: "villagemaster",
    pageLabel: "Village Master",
    pageType: "history",
    form: [
      {
        inputType: "displaytext",
        
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        label: "Region",
        description: "Enter Region"
      }, 
      {
        inputType: "autocomplete",
        isRequired: true,
        
        default: "",
        elementProps: {
          stayOpen: false,
          removeSelected: true,
          disabled: false,
          rtl: false
        },
        widths: {
          parent: "col-sm-10",
          children: "col-sm-12"
        },
        options: [],
        ajaxLoad: true,
        ajaxOptions: {
          query: {
            dialect: "mongodb",
            query: "getRegionname",
            fieldType: "string",
            filters: ["pageData", "regionname"]
          },
          label: "display",
          value: "display"
        },
         placeHolder: "Region",
        name: "region",
        description: "Enter Region"
      },
      {
        inputType: "displaytext",
        
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        label: "Circle",
        description: "Enter Circle"
      }, 
      {
        inputType: "autocomplete",
        isRequired: true,
        
        default: "",
        elementProps: {
          stayOpen: false,
          removeSelected: true,
          disabled: false,
          rtl: false
        },
        widths: {
          parent: "col-sm-10",
          children: "col-sm-12"
        },
        options: [],
        ajaxLoad: true,
        ajaxOptions: {
          query: {
            dialect: "mongodb",
            query: "getCircleName",
            fieldType: "string",
            filters: ["pageData", "circlename"],
            dependsOn:[{region:"region.value"}]
          },
          label: "display",
          value: "display"
        },
         placeHolder: "Circle",
        name: "circle",
        description: "Enter Circle"
      },
      {
        inputType: "displaytext",
        
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        label: "Sub Circle",
        description: "Enter Sub Circle"
      }, 
      {
        inputType: "autocomplete",
        isRequired: true,
        
        default: "",
        elementProps: {
          stayOpen: false,
          removeSelected: true,
          disabled: false,
          rtl: false
        },
        widths: {
          parent: "col-sm-10",
          children: "col-sm-12"
        },
        options: [],
        ajaxLoad: true,
        ajaxOptions: {
          query: {
            dialect: "mongodb",
            query: "getSubCircleName",
            fieldType: "string",
            filters: ["pageData", "subcirclename"],
            dependsOn:[{region:"region.value"},{circle:"circle.value"}]
          },
          label: "display",
          value: "display"
        },
         placeHolder: "Sub Circle",
        name: "subCircle",
        description: "Enter Sub Circle"
      },
        {
            inputType: "displaytext",
            tab: "profile",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            label: "Village",
            description: "Enter Village"
          },
          {
            inputType: "text",
            tab: "profile",
            widths: {
              parent: "col-sm-10",
              children: "col-sm-12"
            },
            placeHolder: "Village",
            name: "VillageEle",
            description: "Enter Village"
          },        
    ],
    history: {
        perPage: 10,
        displayColumns: [
          {
            Header: "Region",
            accessor: "region.value",
          },
          {
            Header: "Circle",
            accessor: "circle.value",
          },
          {
            Header: "Sub Circle",
            accessor: "subCircle.value",
          },
          {
            Header: "Village",
            accessor: "VillageEle",
          },
          
         
        ]
      },
    report: {
        perPage: 10,
        queryType: "mysqlQuery",
        //   groupBy: ["schedule","subschedule"],
        query: [
          {
            dialect: "mysql",
            seq: 1,
            columnHeader: [
              {
                id: "balance1",
                headerText: "trdate",
                headerFrom: "balance"
              }
            ],
            query: ""
          }
        ],
        displayColumns: [
          {
            Header: "Village",
            accessor: "VillageEle",
          },
          
        ]
      }
    
  };

export default villagemaster;